import React, { MouseEvent } from 'react';
import {
  ChevronDownIcon, PencilIcon, TrashIcon, XMarkIcon,
} from '@heroicons/react/20/solid';
import { useSelector } from 'react-redux';
import Button from '../../../../../elements/Button';
import { useAppDispatch } from '../../../../../app/hooks';
import { resetCreateProductForm, setDeleteProductModalData } from '../productsModuleSlice';
import { RootState } from '../../../../../app/store';

interface ProductViewHeaderProps {
  productViewInEditMode: boolean,
  setProductViewInEditMode: (flag: boolean) => void,
  productName: string,
  productID: number,
  inEditMode: boolean,
  open: boolean, // disclosureIsOpen
}

export default function ProductViewHeader(props: ProductViewHeaderProps) {

  const {
    productName, open, inEditMode, productID,
    productViewInEditMode, setProductViewInEditMode,
  } = props;

  const {
    createProductFormData,
  } = useSelector((state: RootState) => state.profileModules.productsModule);

  const dispatch = useAppDispatch();

  const displayName = createProductFormData[productID] ? createProductFormData[productID].productName : productName;

  const onDelete = (e: MouseEvent) => {
    e.stopPropagation();

    dispatch(setDeleteProductModalData({
      productID,
      productName,
      showModal: true,
    }));
  };

  const onEdit = (e: MouseEvent) => {
    if (open) { //  - allow open/close of a tab
      e.stopPropagation();
    }

    setProductViewInEditMode(true);
  };

  const onCancelEdit = (e: MouseEvent) => {
    if (! open) { //  - allow open/close of a tab
      e.stopPropagation();
    }

    setProductViewInEditMode(false);
    dispatch(resetCreateProductForm(productID));
  };

  return (
    <>
      <div className="flex flex-col px-4 py-4 items-start">
        <span className="text-xs text-neutral-700">
          Product name
        </span>
        <span className="font-semibold text-base text-neutral-800">
          {displayName}
        </span>
      </div>
      <div className="flex flex-row items-center">
        {
          // todo: extract callbacks
          inEditMode && (
            <div className="mr-2.5 flex flex-row">
              <Button
                onClick={onDelete}
                size="small"
                inverted
                redText
                roundedFull
                // disabled
                iconLeft={<TrashIcon className="w-4 h-4 mr-2" />}
                description="Delete"
              />
              <div className="ml-2">
                {
                  productViewInEditMode ? (
                    <Button
                      onClick={onCancelEdit}
                      size="small"
                      inverted
                      roundedFull
                      // disabled
                      iconLeft={<XMarkIcon className="w-4 h-4 mr-2" />}
                      description="Cancel"
                    />
                  ) : (
                    <Button
                      onClick={onEdit}
                      size="small"
                      inverted
                      roundedFull
                      // disabled
                      iconLeft={<PencilIcon className="w-4 h-4 mr-2" />}
                      description="Edit"
                    />
                  )
                }
              </div>
            </div>
          )
        }
        <ChevronDownIcon
          className={`${open ? 'transform rotate-180' : ''} w-4 h-4 mr-5 text-main-400`}
        />
      </div>
    </>
  );
}
